import { Fragment, useCallback, useEffect, useState } from 'react';
import clock from '~/assets/icons/clock.svg';
import logo from '~/assets/icons/logo.png';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { numWord } from '~/shared';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledDivider,
	StyledLogoContainer,
	StyledTimerContainer,
} from './BanScreen.styled';

const BanScreen = () => {
	const isPlayerBanned = useObservable(rage.restrictions.isPlayerBanned());
	const isPlayerKicked = useObservable(rage.restrictions.isPlayerKicked());
	const banReason = useObservable(rage.restrictions.getBanReason());
	const kickReason = useObservable(rage.restrictions.getKickReason());
	const banDuration = useObservable(rage.restrictions.getBanExpiresAt());

	const [timeLeft, setTimeLeft] = useState<{
		amount: number | null;
		label: string;
	}>({
		amount: null,
		label: '',
	});

	const [isBanExpired, setBanExpired] = useState(false);

	const countRemainingTime = useCallback(() => {
		if (banDuration === undefined) {
			setTimeLeft({ amount: null, label: '' });
			setBanExpired(false);
			return;
		}

		if (banDuration === null) {
			setTimeLeft({ amount: null, label: 'навсегда' });
			setBanExpired(false);
			return;
		}

		const diff = banDuration - Date.now();

		if (diff <= 0) {
			setTimeLeft({ amount: null, label: '' });
			setBanExpired(true);
			return;
		}

		const minuteMs = 60 * 1000;
		const hourMs = 60 * minuteMs;
		const dayMs = 24 * hourMs;

		if (diff >= dayMs) {
			const days = Math.ceil(diff / dayMs);
			setTimeLeft({
				amount: days,
				label: numWord(days, ['день', 'дня', 'дней']),
			});
			return;
		}

		if (diff >= hourMs) {
			const hours = Math.ceil(diff / hourMs);
			setTimeLeft({
				amount: hours,
				label: numWord(hours, ['час', 'часа', 'часов']),
			});
			return;
		}

		if (diff >= minuteMs) {
			const minutes = Math.ceil(diff / minuteMs);
			setTimeLeft({
				amount: minutes,
				label: numWord(minutes, ['минута', 'минуты', 'минут']),
			});
			return;
		}

		setTimeLeft({ amount: 1, label: 'минута' });
		setBanExpired(false);
	}, [banDuration]);

	useEffect(() => {
		countRemainingTime();
		if (banDuration === undefined || banDuration === null) {
			return;
		}

		const interval = setInterval(countRemainingTime, 60000);
		return () => clearInterval(interval);
	}, [countRemainingTime]);

	return (
		<Fragment>
			<StyledContainer>
				<Text
					style={{
						fontSize: 20,
						fontWeight: 500,
						color: '#ffffff',
						textAlign: 'center',
					}}
				>
					{isPlayerBanned && 'Вы заблокированы!'}
					{isPlayerKicked && 'Вы были кикнуты!'}
				</Text>
				<Text
					style={{
						fontSize: 16,
						color: 'rgba(255,255,255,0.5)',
						textAlign: 'center',
						marginTop: 22,
					}}
				>
					Причина: {isPlayerBanned ? banReason : kickReason}
				</Text>
				{isPlayerBanned && (
					<Fragment>
						{banDuration ? <StyledDivider style={{ marginTop: 26 }} /> : null}
						{banDuration ? (
							<Fragment>
								{!isBanExpired ? (
									<StyledBottomContainer>
										<Text
											style={{
												fontSize: 16,
												color: 'rgba(255,255,255,0.5)',
											}}
										>
											До конца блокировки:
										</Text>
										{timeLeft.amount !== null ? (
											<StyledTimerContainer>
												<Text style={{ fontSize: 16, color: '#fff' }}>
													<span style={{ fontWeight: 500 }}>
														{timeLeft.amount}
													</span>
													&nbsp;
													{timeLeft.label}
												</Text>
												<img src={clock} />
											</StyledTimerContainer>
										) : (
											<StyledTimerContainer>
												<Text style={{ fontSize: 16, color: '#fff' }}>
													{timeLeft.label}
												</Text>
												<img src={clock} />
											</StyledTimerContainer>
										)}
									</StyledBottomContainer>
								) : (
									<Text
										style={{
											fontSize: 16,
											color: '#ffffff',
											textAlign: 'center',
											marginTop: 22,
										}}
									>
										Время блокировки истекло, перезайдите в игру
									</Text>
								)}
							</Fragment>
						) : null}
					</Fragment>
				)}
			</StyledContainer>
			<StyledLogoContainer>
				<img src={logo} />
			</StyledLogoContainer>
		</Fragment>
	);
};

export { BanScreen };
